import React from 'react'

const PageEvents = ({ slice }) => {

    return (
        <section className="page-events">
            <div className="container">
                <div className="four-columns bb-12">
                    <div>
                        <p className="no-margin">Event name</p>
                    </div>
                    <div>
                        <p className="no-margin">Date</p>
                    </div>
                    <div>
                        <p className="no-margin">Location</p>
                    </div>
                    <div>
                        <p className="no-margin">Documents</p>
                    </div>
                </div>
                {slice.items.map((item, index) => (
                    <div className="four-columns bb-24 pt-24">
                        <div>
                            <p className="no-margin font-heavy font-large">{item.name.text}</p>
                        </div>
                        <div>
                            <p className="no-margin font-large">{item.date.text}</p>
                        </div>
                        <div>
                            <p className="no-margin font-large">{item.location.text}</p>
                        </div>
                        <div>
                            <p className="no-margin font-large"><a href={item.document_link.url} className="link mr-24" target="_blank" rel="noreferrer">{item.document_extension.text}</a></p>
                        </div>
                    </div>
                ))}

            </div>
        </section>
    )
}

export default PageEvents